var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"content"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.val)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }